import * as React from "react";

import styled from "@emotion/styled";
import { Link } from "gatsby";

const StyledArrowLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  text-transform: uppercase;

  &,
  path {
    transition: all 0.2s;
  }

  &:hover,
  &:focus {
    color: var(--green);
  }

  svg {
    width: 1.6rem;
    height: 1.6rem;
    margin-left: var(--micro);
  }
`;

export interface ArrowLinkProps {
  url: string;
  text?: string;
}

export const ArrowLink = ({ url, text }: ArrowLinkProps) => (
  <StyledArrowLink to={url}>
    {text ? text : "Read More"}
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.05 15.155c-.32 0-.64-.12-.88-.37a1.25 1.25 0 0 1 0-1.77l5.02-5.02-5.02-5.02a1.25 1.25 0 0 1 0-1.77 1.25 1.25 0 0 1 1.77 0l5.9 5.9c.49.49.49 1.28 0 1.77l-5.9 5.9c-.25.26-.57.38-.89.38Z"
        fill="currentColor"
      />
    </svg>
  </StyledArrowLink>
);
